import { SVGProps } from 'react';

export const HeatMapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='12'
    viewBox='0 0 14 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M3 2L11.25 2' strokeWidth='1.7' strokeLinecap='round' />
    <path d='M3 10H11.25' strokeWidth='1.7' strokeLinecap='round' />
    <path d='M1 6H4' strokeWidth='1.7' strokeLinecap='round' />
    <path d='M8 6L13 6' strokeWidth='1.7' strokeLinecap='round' />
  </svg>
);
